export enum reportReasonEnum {
  spam = "spam",
  abuse = "abuse",
  harassment = "harassment",
  inappropriate_content = "inappropriate_content",
  fake_account = "fake_account",
  misinformation = "misinformation",
  violence = "violence",
  hate_speech = "hate_speech",
  copyright_violation = "copyright_violation",
  scam = "scam",
  trolling = "trolling",
  illegal_activity = "illegal_activity",
  other = "other",
}
